<template>
  <div>
    <zj-layout-container>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          权限管理
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
export default {
  name: 'ZjPermissionHome',
  controller: 'UI',
  action: 'Home'
}  
</script>
